import { render, staticRenderFns } from "./RegisterH5.vue?vue&type=template&id=787d02d6&scoped=true"
import script from "./RegisterH5.vue?vue&type=script&lang=js"
export * from "./RegisterH5.vue?vue&type=script&lang=js"
import style0 from "./RegisterH5.vue?vue&type=style&index=0&id=787d02d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d02d6",
  null
  
)

export default component.exports